import React, { Component } from 'react'
import { IntlProvider, injectIntl } from 'react-intl'

// Constants
import { DEFAULT_LOCALE } from 'components/dashboard/constants'

class NotFound extends Component {
  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  render() {
    return (
      <div className="error-page">
        <h1>{this.t('Exception.PageNotFound')}</h1>
        <a href={this.link('/')} className="btn btn-xs btn-dark-blue">{this.t('Exception.ReturnToHomepage')}!</a>
      </div>
    )
  }
}

export default injectIntl(NotFound)



// WEBPACK FOOTER //
// ./app/javascript/components/exception/not_found.js